export default {
  methods: {
    formatDecimal: function (value) {
      value = '' + value;
      return RegExp(/^-?[0-9]+[,.]?[0-9]{0,2}$/).test(value) ? value.replace(',', '.') : null;
    },
    filterCompare: function (value, filterValue, filterMode) {
      const diff = +value - +filterValue > 0 ? 1 : +value - +filterValue < 0 ? -1 : 0;
      return filterMode === diff;
    },
    filterDateBetween: function (value, filterValueFrom, filterValueTo) {
      const von = filterValueFrom ? this.$helpers.dateToTime(filterValueFrom) : null;
      const bis = filterValueTo ? this.$helpers.dateToTime(filterValueTo) : null;
      return von && bis ? von <= value && value <= bis : von ? von <= value : value <= bis;
    },
    filterDefault: function (value, search) {
      return value != null && typeof value !== 'boolean' && value.toString().toLowerCase().indexOf(search.trim().toLowerCase()) !== -1;
    }
  }
};
